export default __webpack_public_path__ + "static/media/982.e1a7d3e2.png";